import { render, staticRenderFns } from "./CategoryAttributeEditor.vue?vue&type=template&id=083c4f55&scoped=true"
import script from "./CategoryAttributeEditor.vue?vue&type=script&lang=js"
export * from "./CategoryAttributeEditor.vue?vue&type=script&lang=js"
import style0 from "./CategoryAttributeEditor.vue?vue&type=style&index=0&id=083c4f55&prod&scoped=true&lang=css"
import style1 from "./CategoryAttributeEditor.vue?vue&type=style&index=1&id=083c4f55&prod&lang=css"
import style2 from "./CategoryAttributeEditor.vue?vue&type=style&index=2&id=083c4f55&prod&scoped=true&lang=css"
import style3 from "./CategoryAttributeEditor.vue?vue&type=style&index=3&id=083c4f55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083c4f55",
  null
  
)

export default component.exports